module.exports = __webpack_public_path__ + "img/silver.ec5cc80f.png";